"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LoadingCircle["default"];
  }
});
var _LoadingCircle = _interopRequireDefault(require("./LoadingCircle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }